const Divider = ({ color, size, leftValue, extra_classes }) => {
    return <div className={`hidden lg:block absolute left-[62%] -translate-x-[62%] w-1 h-[30%]  bottom-[5rem] mb-20 border-main border-[1px] bg-main ${extra_classes}`}></div>
}
export default Divider